export const TABS = [
  { id: "overview", label: "통합 개요", description: "수익과 사용자 흐름", icon: "OV" },
  { id: "ad", label: "광고 수익", description: "AdMob · MAX", icon: "AD" },
  { id: "ga4", label: "GA4", description: "사용자와 리텐션", icon: "GA" },
  { id: "iap", label: "IAP 분석", description: "구매와 상품 분석", icon: "IA" },
  { id: "admin", label: "관리", description: "수집과 데이터 관리", icon: "AM", adminOnly: true },
];

export const PLATFORM_LABELS = {
  android: "Android",
  ios: "iOS",
  onestore: "OneStore",
  all: "전체 플랫폼",
};

export const COLOR_A = "#4f46e5";
export const COLOR_B = "#ea580c";

export const PERIOD_PRESETS = [7, 14, 30, 90];

